import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContentProperty } from '../types/content-property';
import { Profile } from "@/../types/profile";
import { Partner } from 'src/types/partner';
import { Teamsite } from 'src/types/teamsite';
import { ContentSettings } from 'src/types/contentSettings';

interface SessionState {
  user?: {
    name?: string | null;
    email?: string | null;
    image?: string | null;
  } | null;
  token?: string | null;
  tenant?: string | null;
  sub?: string | null;
  contentProperties: ContentProperty[];
  profiles: Profile[];
  pcnProperties: ContentProperty[];
  companyProfile?: Partner | null;
  teamsites: Teamsite[];
  contentSettings: ContentSettings | null;
}

const initialState: SessionState = {
  user: null,
  token: null,
  tenant: null,
  sub: null,
  contentProperties: [],
  profiles: [],
  pcnProperties: [],
  companyProfile: null,
  teamsites: [],
  contentSettings: null,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSession: (state, action: PayloadAction<SessionState>) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.sub = action.payload.sub;
      if(action.payload.tenant !== state.tenant) {
        console.log("Tenant changed from", state.tenant, "to", action.payload.tenant);
        state.tenant = action.payload.tenant;
      }
    },
    setContentProperties: (state, action: PayloadAction<ContentProperty[]>) => {
      state.contentProperties = action.payload;
    },
    setProfiles: (state, action: PayloadAction<Profile[]>) => {
      state.profiles = action.payload;
    },
    setPcnProperties: (state, action: PayloadAction<ContentProperty[]>) => {
      state.pcnProperties = action.payload;
    },
    clearSession: (state) => {
      state.user = null;
      state.token = null;
      state.tenant = null;
      state.sub = null;
    },
    setCompanyProfile: (state, action: PayloadAction<Partner|null>) => {
      state.companyProfile = action.payload;
    },
    setTeamsites: (state, action: PayloadAction<Teamsite[]>) => {
      state.teamsites = action.payload;
    },
    setContentSettings: (state, action: PayloadAction<ContentSettings|null>) => {
      state.contentSettings = action.payload;
    }
  },
});

export const { setSession, clearSession, setContentProperties, setProfiles, setPcnProperties, setCompanyProfile, setTeamsites, setContentSettings } = sessionSlice.actions;
export default sessionSlice.reducer;